import { getConsoleGroupingData } from "../../Console/Component/services/apiHandler";


export const fetchStandaloneGroupData = (project_ids, browse_fs_ids, currentCompProjectId) => {
    console.log(project_ids, browse_fs_ids, currentCompProjectId,"kjjbbb");
    return dispatch => {
        dispatch({type: "S_ACTION_START"})
        getConsoleGroupingData(project_ids, browse_fs_ids, currentCompProjectId).then((result)=>{
            dispatch({
                type: "S_FETCH_DATA",
                payload: {data: result.data, set_payload: JSON.stringify({project_ids, browse_fs_ids, currentCompProjectId})}
            })
        }).catch((err)=>{
            dispatch({
                type:"S_FETCH_DATA_FAILED",
                payload: err.response.data.error
            })
        })        
    }
}